<ng-container>
  <span
    class="claim-details-button"
    (click)="openClaimDetails(data)">
    {{ data[fieldName] }}
  </span>
</ng-container>
